// extracted by mini-css-extract-plugin
export default {"container":"styles-module--container--3sfw6","menu":"styles-module--menu--tg5gm"};